import { oembedIsBusy } from './OembedStore';

import { oembedIsBusyDefault } from './OembedStoreDefaults';

export const resetOembedIsBusy = () => {
	oembedIsBusy.set(oembedIsBusyDefault);
};
